// removed by extract-text-webpack-plugin
module.exports = {"container":"HoldRequestInput-style__container__741be623","checkbox":"HoldRequestInput-style__checkbox__741be623","checked":"HoldRequestInput-style__checked__741be623","icon":"HoldRequestInput-style__icon__741be623","label":"HoldRequestInput-style__label__741be623"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/ContactDealer/HoldRequestInput-style.scss
// module id = 3454
// module chunks = 7